module.exports = __webpack_public_path__ + "img/3-3.dd40aa7a.png";